import { useMemo } from "react";
// COMPONENTS

// CSS
import "./Dashboard.css";
import { BrandGAds, BrandGAnalytics, BrandMeta, BrandShopify, OogwaiLogo2, OogwaiTextLogo, YoutubeLogo } from "../../components/Icons/iconImages";
import {
  useGetAnalyticStatusQuery,

} from "../../services/integrationSlice";
import { useNavigate } from "react-router-dom";
import Loading from "../../components/Loading";
import { Button } from "../../components/Buttons";
import { useForm } from "react-hook-form";
import IconRings from "../../components/IconRings";
// TODO: Need to work on the modal stylings
import { IntegrationComponent } from "./IntegrationComponent";

const FirstIntegrations = ({ signup }) => {
  const navigate = useNavigate();

  const { control, getValues, setError, reset, watch } = useForm({
    defaultValues: {
      dontShowAgain: false,
    },
    shopUrl: '',
  });

  const { data: getStatus, refetch, error, isLoading } = useGetAnalyticStatusQuery();


  // if (error) {
  //   toast.error(error?.data?.message || 'Unexpected error');
  // }

  const iconMap = useMemo(() => ({
    BrandGAnalytics: BrandGAnalytics,
    BrandShopify: BrandShopify,
    BrandMeta: BrandMeta,
    BrandGAds: BrandGAds,
    BrandYoutube: YoutubeLogo,
  }), []);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <>
      <section className="relative" style={{ height: !signup ? `calc(max(100vh - 200px, 540px))` : '' }}>
        {!signup && <div className="h-5 overflow-visible">
          <IconRings ringColor={'#b6f0d5ab'} numRings={10} ringBaseSize={26} ringSpacing={80} className="mt-32" />
        </div>}
        <div className={`relative flex flex-col h-full justify-between rounded-3xl bg-white max-w-[576px] mx-auto ${!signup ? ' border border-gray-200 shadow-sm ' : ''} `} >
          <div className="flex flex-col gap-5 p-8 overflow-y-auto">
            {!signup && <div className="flex flex-col items-center">
              <OogwaiLogo2 className="w-[72px] h-[72px]" />
              <OogwaiTextLogo />
            </div>}
            {!signup && <div className="flex flex-col gap-2 items-center">

              <h3 className="text-[#414651]">Welcome to Oogw.ai</h3>
              <p className="text-sm">Connect to an Analytics platform you use</p>
            </div>}
            <IntegrationComponent
              className={`${!signup ? " sm:grid-cols-2 " : ''} grid grid-cols-1  gap-4`}
              iconMap={iconMap}
              control={control}
              setError={setError}
              reset={reset}
              getValues={getValues}
              watch={watch}
              signup={signup}
            />
          </div>

          {!signup && <div className="px-6 py-3 border-t border-gray-200 flex justify-between items-center">
            <Button
              type="text"
              iconPosition="left"
              onClick={() => navigate('/dashboard')}
            >
              Skip
            </Button>
            <Button
              type="primary"
              disabled={
                Object.entries(getStatus || {})
                  .filter(([key, value]) => typeof value === 'boolean')
                  .every(([key, value]) => !value)
              }
              onClick={() => {
                // navigate('/dashboard');
                window.location.href = '/dashboard'
              }}
            >
              Take me to Dashboard
            </Button>
          </div>}
        </div>
        {/* <IconRings ringColor={'#b6f0d5ab'} numRings={9} ringBaseSize={10} ringSpacing={115} className="-z-0" /> */}
      </section >
    </>
  );
};

export default FirstIntegrations;